module.exports = __webpack_public_path__ + "static/media/29EUNOG9.685892a6.jpg";